import { render, staticRenderFns } from "./SingleUploadButtons.vue?vue&type=template&id=c8a96f8a&"
import script from "./SingleUploadButtons.vue?vue&type=script&lang=js&"
export * from "./SingleUploadButtons.vue?vue&type=script&lang=js&"
import style0 from "./SingleUploadButtons.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports